<template>
  <div class="kp-list-group-item clearfix" v-if="boxFormat !== 'component'">
    <label
      class="kp-row box-title box-title__button"
      style="cursor: pointer"
      @click="sidebarChangePanel('triggerbutton');canvasChangeView('triggerbutton')">
      {{ $t('edit.sidebar.call_button_style') }}
      <div class="pull-right">
        <span class="btn is-circular has-icon"><i class="fa fa-cog"></i></span>
      </div>
    </label>
    <span></span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  methods: mapActions([
    'sidebarChangePanel',
    'canvasChangeView',
  ]),
  computed: mapGetters({
    boxFormat: 'boxFormat',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** TriggerButton.vue?4e21fc6c
 **/